/*@ngInject*/
const RequiredIndicatorLabelController = function($element) {
    this.$onInit = function() {
        $element.addClass('requiredIndicatorComponent');
        this.className = this.config.bold ? 'isBold' : '';
    };

    this.$onChanges = function() {
        this.className = this.config.bold ? 'isBold' : '';
    };
};

angular.module('umFormViewer')
    .controller('requiredIndicatorLabelController', RequiredIndicatorLabelController);
